/* src/app/warehousing/pages/cost-history/cost-history.component.scss */
/*# sourceMappingURL=cost-history.component.css.map */
